import React, { useState } from 'react';
import {  faGraduationCap, faHouseChimney, faPlane,  faShop, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

import { AppHeader } from '../../components/header/header';
import { carouselData,  newsItems } from '../../_helpers/mock-data';
import { SlideAnim } from '../../components/utilities/slider';
import { SectionHeader } from '../../components/page-components/section-header';
import { VisaTypeBox } from '../../components/page-components/visa-type-box';
import { ObjectAnim } from '../../components/utilities/intersection';
import { FunSlide } from '../../components/utilities/slide-right';
import { LeftAnim } from '../../components/utilities/slide-left';
import "../../styles/faq.css";
import { FaqSection } from '../../components/faqs/section-unit';
import { ChooseCountry } from '../../components/countries/countries';
import { NewsItem } from '../../components/news/news';
import { NewsLetterBox } from '../../components/footer/newsletter';
import { ContactForm } from '../../components/footer/contact-map';
import { AppFooter } from '../../components/footer/footer';
import { BodySpacer } from '../../components/utilities/body-spacer';
import { visaText } from '../../_helpers/visa-data';






export const HomePage = () => {

    const [onAlert, setOnalert] = useState(false);
    const [alertData, setAlertData] = useState()
   
    const {study, work, tourist, commercial, residence} = visaText;




    const navigateTo = useNavigate();

    return (
        <div className="page-body">
            <AppHeader data={alertData} onAlert={onAlert} />
            <BodySpacer />
            <div className='home-page-carousel'>
                <SlideAnim data={carouselData} />
            </div>
            <div className='dir-note'>
                <div className='note-txt'>
                    <img src='/open-quote.svg' alt='' width={50} />
                    <div>
                        With the desire to empower youths and alleviate poverty, AKUM DENIS TANGRI had a dream to create a company that will be outstanding in the recruitment and placement of students and professionals to recognized Universities around the world not only to get internationally recognized certificates, but to add more value to their certificates and know how in their respective field. The dream is a reality today with UNIVERSAL EDUCATION SERVICES AND TRAVELS
                    </div>
                </div>
            </div>
            <section className='about-section'>
                <SectionHeader caption={"About Us"} />
                <div 
                    className='section-unit'
                >
                    <div className='section-text'>
                        <p>
                            <a href="/">Universal Education Services and Travels</a> is student recruitment and placement agency that deals with the orientation, guidance and counseling of students who wish to further their studies abroad. 
                            We do offer a smooth and fast admission process for different countries such as the U.S.A, Canada, Malaysia, Turkey, Cyprus, Germany, Belgium, china, Ireland, U.K. etc. we also assist students who have different preferences for their studies and give guidance on Visa requirements and immigration issues...

                        </p>
                        <button 
                            className="learn-more"
                            onClick={() => navigateTo("/about") }
                        >
                            Learn more
                        </button>
                    </div>
                    <img src='./images/students.jpg' className='section-image' alt='' />
                    
                </div>
            </section>
            <div className='h-d-box'>
                <SectionHeader caption={"Visa types and eligibility"} />
            </div>
            <div 
                className='v-t-box'
            >
                <div className='v-t-group'>
                    <ObjectAnim>
                        <VisaTypeBox 
                            boxColor={"#df590b"} 
                            boxIcon={faPlane}
                            text={tourist.text}
                            caption={"Tourist Visa"} 
                        />
                    </ObjectAnim>
                    <FunSlide>
                        <VisaTypeBox 
                            boxColor={"#1679dd"} 
                            boxIcon={faShop}
                            text={commercial.text}
                            caption={"Commercial Visa"} 
                        />
                    </FunSlide>
                    <img
                        className='v-s-img'
                        src='/images/stud-visa.avif'
                        width={350}
                        alt=''
                    />
                </div>
                <div className='v-t-group'>
                    <LeftAnim>
                        <VisaTypeBox 
                            boxColor={"#5c04bb"} 
                            boxIcon={faGraduationCap}
                            text={study.text}
                            caption={"Student Visa"} 
                        />
                    </LeftAnim>
                    <ObjectAnim>
                        <VisaTypeBox 
                            boxColor={"#37b27d"} 
                            boxIcon={faHouseChimney}
                            text={residence.text}
                            caption={"Residence Visa"} 
                        />
                    </ObjectAnim>
                    <FunSlide>
                        <VisaTypeBox 
                            boxColor={"#eec019"} 
                            boxIcon={faUserTie}
                            text={work.text}
                            caption={"Working Visa"} 
                        />
                    </FunSlide>
                </div>
            </div>
            <SectionHeader caption={"MakeYour Prefared Nation Choice"}/>
            <ChooseCountry 
                nav={true}
            />
            <SectionHeader caption={"Common Questions Answered"} />
            <FaqSection />
            
            <div className='v-t-box' style={{backgroundSize: "cover"}}>
                <SectionHeader caption={"Cast Your Eyes Upon Our Newest Article"} />
                <div className='news-box'>
                    <NewsItem data={newsItems[0]}/>
                    <NewsItem data={newsItems[1]} />
                    <NewsItem data={newsItems[2]} />
                </div>
            </div>
            <NewsLetterBox />
            <ContactForm 
                alertError={() => setOnalert(true)}
                setDataError={() => setAlertData({     
                    caption: "Invalid Data",
                    message: "Please provide all necessary data",
                    accept: "Ok",
                    abort: "Cancel",
                    handleAccept: () => alert("Accepted"),
                    handleAbort: () => setOnalert(false),
                    handleClose: () => setOnalert(false)
                })}
            />
            <AppFooter />
        </div>
    )
}